export const compose = (f, g) => (x) => f(g(x));

export const curry = (fn) => {
  return function curry(...args) {
    return args.length >= fn.length ? fn(...args) : curry.bind(null, ...args);
  };
};
